const Typography = {
	MuiTypography: {
		defaultProps: {},
		styleOverrides: {
			paragraph: {
				display: 'block',
			},
		},
	},
}

export default Typography
